import clsx from 'clsx';
import { AnimatePresence, motion } from 'framer-motion';
import { Typography } from '../../Core/Typography/Typography';
import { RollingAmountProps } from './RollingAmount';

const textComponent = (
  character: string,
  isPortfolioAmount: boolean,
  isCents: boolean,
  portfolioAmountClassName?: string,
  amountClassName?: string,
  amountCentsClassName?: string,
) => {
  return isPortfolioAmount ? (
    <>
      {isCents ? (
        <Typography size="small" className={clsx(amountCentsClassName)}>{character}</Typography>
      ) : (
        <Typography className={clsx('text-5xl', portfolioAmountClassName)}>{character}</Typography>
      )}
    </>
  ) : (
    <Typography size="medium" className={clsx(amountClassName)}>{character}</Typography>
  );
};

function RollingCharacter({
  character,
  isPortfolioAmount,
  isCents,
  portfolioAmountClassName,
  amountClassName,
  amountCentsClassName
}: {
  character: string;
  isPortfolioAmount: boolean;
  isCents: boolean;
  portfolioAmountClassName?: string;
  amountClassName?: string;
  amountCentsClassName?: string;
}) {
  return (
    <motion.div
      className={isCents ? 'mb-1' : ''}
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{
        duration: 0.4,
        ease: 'easeOut',
      }}>
      {textComponent(character, isPortfolioAmount, isCents, portfolioAmountClassName, amountClassName, amountCentsClassName)}
    </motion.div>
  );
}

export const RollingAmount = ({
  amount,
  isPortfolioAmount,
  className,
  portfolioAmountClassName,
  amountClassName,
  amountCentsClassName
}: RollingAmountProps) => {
  return (
    <div
      className={clsx('flex flex-row  overflow-hidden items-end', className)}>
      <AnimatePresence>
        {amount.split('').map((character, index) => (
          <RollingCharacter
            key={`${character}-${index}`}
            character={character === ' ' ? '\u00A0' : character}
            isPortfolioAmount={isPortfolioAmount}
            portfolioAmountClassName={portfolioAmountClassName}
            amountClassName={amountClassName}
            amountCentsClassName={amountCentsClassName}
            isCents={
              isPortfolioAmount &&
              amount.includes('.') &&
              index >= amount.indexOf('.')
            }
          />
        ))}
      </AnimatePresence>
    </div>
  );
};
